import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
 
@Injectable({
  providedIn: 'root'
})
export class LeadService {
  //  private authUrl = 'https://upscap2023--upscuat.sandbox.my.salesforce.com/services/oauth2/token';
  //  private leadUrl = 'https://upscap2023--upscuat.sandbox.my.salesforce.com/services/apexrest/leadcreate/v1/';

  private authUrl = 'https://upscap2023.my.salesforce.com/services/oauth2/token';
  private leadUrl = 'https://upscap2023.my.salesforce.com/services/apexrest/leadcreate/v1/';
  
    
  private countryNames: { [key: string]: string } = {
    'CA': 'Canada', 'CN': 'China', 'FR': 'France', 'DE': 'Germany',
    'HK': 'Hong Kong', 'IT': 'Italy', 'MX': 'Mexico', 'NL': 'Netherlands',
    'PL': 'Poland', 'ES': 'Spain', 'BE': 'Belgium', 'TH': 'Thailand',
    'GB': 'United Kingdom', 'US': 'United States'
  };
 
  private stateMapping: { [key: string]: string } = {
    "AL": "Alabama", "AK": "Alaska", "AZ": "Arizona", "AR": "Arkansas",
    "CA": "California", "CO": "Colorado", "CT": "Connecticut", "DE": "Delaware",
    "FL": "Florida", "GA": "Georgia", "HI": "Hawaii", "ID": "Idaho",
    "IL": "Illinois", "IN": "Indiana", "IA": "Iowa", "KS": "Kansas",
    "KY": "Kentucky", "LA": "Louisiana", "ME": "Maine", "MD": "Maryland",
    "MA": "Massachusetts", "MI": "Michigan", "MN": "Minnesota", "MS": "Mississippi",
    "MO": "Missouri", "MT": "Montana", "NE": "Nebraska", "NV": "Nevada",
    "NH": "New Hampshire", "NJ": "New Jersey", "NM": "New Mexico", "NY": "New York",
    "NC": "North Carolina", "ND": "North Dakota", "OH": "Ohio", "OK": "Oklahoma",
    "OR": "Oregon", "PA": "Pennsylvania", "RI": "Rhode Island", "SC": "South Carolina",
    "SD": "South Dakota", "TN": "Tennessee", "TX": "Texas", "UT": "Utah",
    "VT": "Vermont", "VA": "Virginia", "WA": "Washington", "WV": "West Virginia",
    "WI": "Wisconsin", "WY": "Wyoming"
  };
 
  constructor(private http: HttpClient) {}
 
  // Get access token
  private getAccessToken(): Observable<string> {
    const body = new URLSearchParams();
    body.set('grant_type', 'password');
   /* body.set('client_id', '3MVG9dPGzpc3kWydGL8XLCOpVpuNPGrhvarmV7Cn7mr4h7zavHDR.lEygovxPpC_.8CK4T9YHqPIWvwCWo8AK');
    body.set('client_secret', 'FAD30235E84D0EED13F0C2195397CE35CD00D1089F1D7CB1A9DEEA79A0FE75A8');
    body.set('username', 'upscapintusr@ups.com.upscuat');
    body.set('password', 'upscapintuat25!flj4LoSTYmcMZYqGugQ2JRuY'); */

    body.set('client_id', '3MVG9Z7_5k1EebWDYtdbuuKJP7ZT8KmTKQXCcS6oGuZPNSqDE.gqj3YVS0lopfW6VeKuYeGg_YroFMb2t5IjZ');
    body.set('client_secret', '3F577D8265890F44E434AA69144344F27F6D244F5A782F0C141F2266346EA414');
    body.set('username', 'upscapintusr@ups.com');
    body.set('password', '1449upscapintwebusr25!2mVtBeYZp5KJnU0RzmCGJEeQ'); 
 
    return this.http.post<any>(this.authUrl, body.toString(), {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      })
    }).pipe(
      map(response => response.access_token),
      catchError(error => {
        console.error('Error fetching access token:', error);
        return throwError(() => new Error('Failed to authenticate'));
      })
    );
  }
 

  // Submit lead
  submitLead(formData: any): Observable<any> {
    // Map country and state codes
    formData.Country = this.countryNames[formData.Country] || formData.Country;
    formData.StateProvinceRegion = this.stateMapping[formData.StateProvinceRegion] || formData.StateProvinceRegion;
 
    // Set HowCanWeHelp text
    let howCanWeHelp = formData.HowCanWeHelp == 1 ? 
      "I am interested in your services" : "I have a service inquiry";
 
    if (formData.CampaignID == 6) {
      howCanWeHelp = "";
    }
 
    return this.getAccessToken().pipe(
      switchMap(accessToken => {
        const leadData = {
          leadData: {
            country: formData.Country,
            state: formData.StateProvinceRegion,
            firstName: formData.FirstName,
            lastName: formData.LastName,
            email: formData.Email,
            phone: formData.PhoneNumber,
            howcanwehelp: howCanWeHelp,
            areyouaUPSCcustomer: "",
            companyname: formData.CompanyName,
            zipcode: formData.Zipcode,
            comments: "",
            channelvalue: "",
            leadsource: "",
            sourcesystem: "UPSCAPITAL.COM",
            referralurl: formData.Referrer
          }
        };
 
        return this.http.post<any>(this.leadUrl, JSON.stringify(leadData), {
          headers: new HttpHeaders({
            'Authorization': `OAuth ${accessToken}`,
            'Content-Type': 'application/json'
          })
        }).pipe(
          map(response => {
            console.log('Lead submitted successfully:', response);
            return response;
          }),
          catchError(error => {
            console.error('Error submitting lead:', error);
            return throwError(() => new Error('Failed to submit lead'));
          })
        );
      })
    );
  }
}